module.exports = __webpack_public_path__ + "static/media/unboxing_spring_5.619983f7.jpg";